// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._157bYP_e4wmxn5K_nnAHMI{background:#25005b;color:#fff;font-size:1rem;padding:.57143rem .5rem;border:none;border-radius:.28571rem;font-family:\"Palanquin Dark\",sans-serif;font-weight:700;cursor:pointer}._157bYP_e4wmxn5K_nnAHMI:focus{outline:none}._157bYP_e4wmxn5K_nnAHMI:hover{background-color:#772ce8}._157bYP_e4wmxn5K_nnAHMI:disabled{background-color:#bcaed1;cursor:default}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "_157bYP_e4wmxn5K_nnAHMI"
};
export default ___CSS_LOADER_EXPORT___;
